import React, {useState, useEffect} from 'react';
import {collection, query, where, limit, getDocs, updateDoc, doc} from 'firebase/firestore';

export function RsvpForm({database, searchInput}) {
    const [guests, setGuests] = useState([]);

    useEffect(() => {
        const guestListRef = collection(database, 'guest-list');
        const userQuery = query(
            guestListRef,
            where('name', '==', searchInput.toLowerCase()),
            limit(1)
        );
        
        (async() => {
            console.log('Querying database for user...');
            const userQueryResult = await getDocs(userQuery);

            if (userQueryResult.empty) {
                console.log('No results found.');
                setGuests(null);
            } else {
                const user = userQueryResult.docs[0];
                const {groupId} = user.data();
                const groupQuery = query(
                    guestListRef,
                    where('groupId', '==', groupId)
                );

                console.log('Found user, querying for group...');

                const groupQueryResult = await getDocs(groupQuery);
                const guests = groupQueryResult.docs.map((guest) => {
                    return {
                        id: guest.id,
                        ...guest.data()
                    };
                });

                setGuests(guests);
            }
        })()
    }, [])

    async function rsvp(e, id, going) {
        const docRef = doc(database, 'guest-list', id);

        console.log('Updating RSVP...')

        await updateDoc(docRef, {going})

        const previouslySelected = document.getElementsByClassName(`${id} selected`);

        if (previouslySelected && previouslySelected[0]) {
            previouslySelected[0].classList.remove('selected');
        }

        e.target.classList.add('selected');
    }

    return (
        <div className='rsvp-form-wrapper'>
            <div className='rsvp-form'>
                {!guests && <span className='not-found'>Your RSVP was not found. Please try again.</span>}
                {guests && guests.map((guest) => {
                    return (
                        <div key={guest.id} className='rsvp-row'>
                            <span>{guest.name}</span>
                            <div className='button-wrapper'>
                                <button
                                    className={guest.going === 'true' ? `${guest.id} selected` : guest.id}
                                    onClick={(e) => rsvp(e, guest.id, 'true')}
                                >
                                    Going
                                </button>
                                <button 
                                    className={guest.going === 'false' ? `${guest.id} selected` : guest.id}
                                    onClick={(e) => rsvp(e, guest.id, 'false')}
                                >
                                    Can't Go
                                </button>
                            </div>
                        </div>
                    );
                })}
                {guests && guests.length > 0 && (
                    <React.Fragment>
                        <p>November 22, 2026</p>
                        <p>5:00pm - 9:00pm</p>
                        <p>Noah's Ark Ristorante<br/>2400 Ingersoll Ave<br/>Des Moines, IA</p>
                        <p>Dress Code: Cocktail Attire</p>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}
